export const ENRICHMENT_SETTINGS = {
  companyEnrichmentAuto: 'enrichment:auto-hydrate',
  companyEnrichmentAutoImports: 'enrichment:companies-auto-hydrate-import',
  companyEnrichmentAutoLastEngagement: 'enrichment:companies-engage',
  companyEnrichmentContinuous: 'enrichment:companies-auto-propagate',
  companyEnrichmentManual: 'enrichment:companies-manual',
  contactEnrichmentAuto: 'enrichment:contacts-auto-hydrate',
  contactEnrichmentAutoImports: 'enrichment:contacts-auto-hydrate-import',
  contactEnrichmentAutoLastEngagement: 'enrichment:contacts-engage',
  contactEnrichmentContinuous: 'enrichment:contacts-auto-propagate',
  contactEnrichmentManual: 'enrichment:contacts-manual',
  conversationalEnrichmentEmailNoLongerAtCompany: 'conversational-enrichment:email:models:no-longer-at-company',
  conversationalEnrichmentEmailOtherContacts: 'conversational-enrichment:email:models:other-contacts',
  conversationalEnrichmentEmailOutOfOffice: 'conversational-enrichment:email:models:out-of-office',
  conversationalEnrichmentEmailSignature: 'conversational-enrichment:email:models:signature',
  enrichmentAutoPause: 'enrichment:auto-pause',
  formsEnrichment: 'enrichment:form-shortening',
  importsEnrichment: 'enrichment:import',
  workflowEnrichment: 'enrichment:workflow-automations'
};
export const ENRICHMENT_SETTINGS_KEYS = Object.keys(ENRICHMENT_SETTINGS);
export const ENRICHMENT_SETTINGS_API_KEYS = Object.values(ENRICHMENT_SETTINGS);

/**
 * Get enrichment setting key from corresponding API key.
 * @param {EnrichmentSettingApiKey} apiKey - The API key to look up.
 * @return {EnrichmentSettingKey} The key corresponding to the provided API key.
 * @example
 * const key = getKey('enrichment:auto-hydrate'); // returns 'companyEnrichmentAuto'
 */
export function getKey(apiKey) {
  return ENRICHMENT_SETTINGS_KEYS.find(key => ENRICHMENT_SETTINGS[key] === apiKey);
}

/**
 * Get enrichment setting API key from corresponding setting key.
 * @param {EnrichmentSettingKey} key - The setting key to look up.
 * @return {EnrichmentSettingApiKey} The API key corresponding to the provided setting key.
 * @example
 * const apiKey = getApiKey('companyEnrichmentAuto'); // returns 'enrichment:auto-hydrate'
 */
export function getApiKey(key) {
  return ENRICHMENT_SETTINGS[key];
}